import { render, staticRenderFns } from "./SimpleHotel.vue?vue&type=template&id=06051131&"
import script from "./SimpleHotel.vue?vue&type=script&lang=js&"
export * from "./SimpleHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports